import { TextField, TextFieldProps } from "@mui/material";
import { forwardRef } from "react";
import {
  MULTI_LINE_INPUT_FIELD_MAX_LENGTH,
  SINGLE_LINE_INPUT_FIELD_MAX_LENGTH,
} from "../../../helpers/inputLimits";

const CommonTextField = forwardRef((props: TextFieldProps, ref) => {
  const getMaxLength = (multiline?: boolean): number =>
    multiline
      ? MULTI_LINE_INPUT_FIELD_MAX_LENGTH
      : SINGLE_LINE_INPUT_FIELD_MAX_LENGTH;
  return (
    <TextField
      {...props}
      autoComplete="off"
      inputRef={ref}
      inputProps={{
        ...props.inputProps,
        maxLength: props.inputProps?.maxLength || getMaxLength(props.multiline),
      }}
      size={props.size || "small"}
    />
  );
});

export default CommonTextField;
